module.exports = [{"name":"Data Processing Addendum (DPA - Editable)","papers":[{"title":"Data Processing Addendum (DPA)","id":"auth0-dpa-editable","icon":"https://cdn.auth0.com/website/assets/pages/legals/img/icon-word-92c794e490.svg","date":"October, 2017","actions":[{"action":"download","file":"https://cdn.auth0.com/website/legal/files/Auth0-DPA.docx"}]}]}]


//////////////////
// WEBPACK FOOTER
// ./src/pages/legals/dpa-editable/data/dpaPapers.json
// module id = 1632
// module chunks = 0